var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#9BFDEB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7384 69.3776C24.6043 65.6738 25.8913 60.9212 29.6083 58.7795L76.7822 31.5981C80.4992 29.4564 85.2564 30.7263 87.3905 34.4301L91.2596 41.1452C91.7916 42.0685 91.4296 43.2414 90.7309 44.0493C89.1443 45.8719 88.8049 48.5691 90.0745 50.7725C91.3441 52.9759 93.8477 54.0349 96.2203 53.5763C97.2696 53.377 98.466 53.6519 98.998 54.5753L102.867 61.2903C105.001 64.9941 103.714 69.7467 99.9972 71.8884L52.8234 99.0698C49.1064 101.212 44.3492 99.9415 42.2151 96.2378L38.3459 89.5227C37.8139 88.5994 38.176 87.4264 38.8746 86.6186C40.4613 84.7959 40.8006 82.0987 39.5311 79.8954C38.2615 77.692 35.7578 76.633 33.3852 77.0916C32.3359 77.2909 31.1396 77.0159 30.6076 76.0926L26.7384 69.3776Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 62,
    fill: "white",
    transform: "translate(19 55.9474) rotate(-29.9503)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.b56b9838424aa5e143c0e876fd9066cb.svg";
export { ForwardRef as ReactComponent };